import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgShuffleIcon from './svgs/ShuffleIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var shuffleIcon = (props => useIcon(SvgShuffleIcon, SvgShuffleIcon, props));

export { shuffleIcon as default };
